import { Quote } from "lucide-react";

const endorsements = [
  {
    quote:
      "Si deeply listens. Not just in election season — every season. She's the leader Ward 3 deserves on the council.",
    name: "Ballentine Resident",
  },
  {
    quote:
      "Sikaiadah listens first and leads second. That is exactly the kind of representation our families have been asking for in Ward 3.",
    name: "Norview Resident",
  },
  {
    quote:
      "I've seen firsthand how Si advocates for Ballentine, and now, she can actively advocate for the full ward which is hopeful and exciting.",
    name: "Ballentine Resident",
  },
];

export const Endorsements = () => {
  return (
    <section
      id="supporters"
      data-testid="endorsements-section"
      className="relative bg-royal py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <div className="mb-14 lg:mb-20 max-w-3xl">
          <p className="text-[11px] tracking-[0.32em] uppercase text-classy-soft mb-4">
            05 — Supporters
          </p>
          <h2
            data-testid="endorsements-heading"
            className="font-serif-display text-classy text-5xl sm:text-6xl lg:text-7xl leading-[0.95] font-medium"
          >
            Together <span className="italic font-light">We</span> Grow Ward 3
            <br />
            — Words of <span className="italic font-light">The</span> People
          </h2>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {endorsements.map((e, idx) => (
            <figure
              key={e.name}
              data-testid={`endorsement-card-${idx}`}
              className="relative bg-royal-deep border border-white/10 p-8 lg:p-10 hover:border-white/30 transition-colors duration-500"
            >
              <Quote
                className="absolute top-6 right-6 text-classy/15"
                size={56}
                strokeWidth={1}
              />
              <blockquote className="font-serif-display italic text-classy text-2xl lg:text-3xl leading-snug mb-8 pr-14 sm:pr-16">
                "{e.quote}"
              </blockquote>
              <figcaption>
                <p className="text-classy text-sm font-semibold tracking-[0.18em] uppercase">
                  — {e.name}
                </p>
                {e.role && (
                  <p className="text-classy-soft/70 text-xs mt-1 tracking-wide">
                    {e.role}
                  </p>
                )}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Endorsements;
